// src/components/ErrorPage.js
import React from 'react';

const ErrorPage = ({ message }) => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            backgroundColor: '#f8f9fa',
            fontFamily: 'Arial, sans-serif'
        }}>
            <h1 style={{ color: '#dc3545', fontSize: '2rem' }}>Access Error</h1>
            <p style={{ maxWidth: '600px', textAlign: 'center', fontSize: '1rem', color: '#333' }}>
                {message}
            </p>
            <p style={{ marginTop: '20px', fontSize: '0.9rem', color: '#666' }}>
                Please contact <a href="mailto:cloud-services@mosaic.siemens-energy.cloud">cloud-services@mosaic.siemens-energy.cloud</a>
                to request access.
            </p>
        </div>
    );
};

export default ErrorPage;
